import FilterSVG from "@design-system/ui-icons/vanilla/Filter"
import { createIcon } from "../createIcon"

export const FilterIcon = createIcon(FilterSVG)
